import {useTranslation} from 'react-i18next';

type CountedLabelKey = 'deposits' | 'sentToBank' | 'outgoingTotal' | 'approved' | 'awaitingReview';

/** A null count (in-flight search failed) drops the "· n" suffix instead of showing a false zero. */
export function useCountedLabel() {
  const {t} = useTranslation('trustAccounts');

  return (key: CountedLabelKey, count: number | null): string =>
    count === null
      ? t(`view.balanceMetric.breakdown.${key}NoCount`)
      : t(`view.balanceMetric.breakdown.${key}`, {n: count});
}
